
import './App.css';

import LandingPage from './LandingPage/LandingPage';


function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
